import ActionTypeFact from "../ActionTypeFact";

export default class BuscarAsociadosAFacturar extends ActionTypeFact{
    ejecutar(estado, nuevoEstado) {    
        nuevoEstado.flag.procesandoComando = true;
        // nuevoEstado.flag.sensorDeAccionABuscar = !(estado.flag.sensorDeAccionABuscar);
        return nuevoEstado;
    }
}